export default __webpack_public_path__ + "static/lalibrairie-jl-desktop@2x-2339a466570c06a407b2ec7dc2008244.jpg";